import CustomLoader from "components/atoms/CustomLoader";
import { APP_LOGOUT_PARAMS } from "models/common.models";
import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

const AppLogin = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // Parse query parameters from the URL
    const searchParams = new URLSearchParams(location.search);
    const redirectUrl = searchParams.get(APP_LOGOUT_PARAMS.REDIRECT_URL);

    // If redirect URL exists, navigate to it
    if (redirectUrl) {
        window.location.href = redirectUrl
    } else {
        history.replace(window.location.origin);
    }
  }, [location, history]);

  return <CustomLoader />;
};

export default AppLogin;
